export default "https://cdn-static.gokick.com/assets/ac547ee441cd23ce845c1e2810a666ddd08d044b/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";